// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__13Rbf","spin":"loader_spin__AthyE"};